import React, { FC } from 'react';

import cn from 'classnames';

import css from './index.css';

interface Props {
    className?: string;
}

export const DotSpin: FC<Props> = ({ className }) => {
    return (
        <div className={cn(css.DotSpin, className)}>
            <div className={css.DotSpin__dot}></div>
            <div className={css.DotSpin__dot}></div>
            <div className={css.DotSpin__dot}></div>
        </div>
    );
};
